import React, { createContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getUserDataWithUsername } from '../common/data/userDummyData';
import meka from "../meka";
const AuthContext = createContext({});
var setLogUser;
export const AuthContextProvider = ({ children }) => {
    const [user, setUser] = useState(false);//JSON.parse(localStorage.getItem('mekaUser')) ||
    const [bag,setBag]=useState({})
    setLogUser=setUser;
    const [userData, setUserData] = useState({});
    const [mainMenu, setMainMenu] = useState({});
    const value = useMemo(() => ({
        user,
        setUser,
        userData,
        setUserData,
        mainMenu,
        setMainMenu,
        bag,
        setBag
    }), [user, userData,mainMenu,bag]);
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
AuthContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
export {setLogUser};
export default AuthContext;
